interface AvatarUser {
  first_name?: string | null;
  last_name?: string | null;
  username?: string | null;
  photo_url?: string | null;
}

type Size = 'xs' | 'sm' | 'md' | 'lg';

const SIZES: Record<Size, { box: string; text: string }> = {
  xs: { box: 'w-6 h-6',           text: 'text-[10px]' },
  sm: { box: 'w-9 h-9',           text: 'text-xs' },
  md: { box: 'w-[42px] h-[42px]', text: 'text-sm' },
  lg: { box: 'w-[60px] h-[60px]', text: 'text-lg' },
};

export function Avatar({
  user,
  size = 'md',
  className = '',
}: {
  user: AvatarUser | null | undefined;
  size?: Size;
  className?: string;
}) {
  const s = SIZES[size];
  return (
    <div
      className={`${s.box} ${s.text} rounded-pill bg-accent text-text-inverse grid place-items-center font-medium overflow-hidden shrink-0 ${className}`}
    >
      {user?.photo_url
        ? <img src={user.photo_url} alt="" className="w-full h-full object-cover" />
        : getInitials(user)}
    </div>
  );
}

export function displayName(user: AvatarUser | null | undefined, fallback = '·'): string {
  if (!user) return fallback;
  const fn = (user.first_name ?? '').trim();
  const ln = (user.last_name ?? '').trim();
  const full = [fn, ln].filter(Boolean).join(' ');
  if (full) return full;
  if (user.username) return `@${user.username}`;
  return fallback;
}

function getInitials(user: AvatarUser | null | undefined): string {
  if (!user) return '·';
  const fn = (user.first_name ?? '').trim();
  const ln = (user.last_name ?? '').trim();
  if (fn && ln) return (fn[0] + ln[0]).toUpperCase();
  if (fn) return fn.slice(0, 2).toUpperCase();
  if (user.username) return user.username.slice(0, 2).toUpperCase();
  return '·';
}
